(function () {
	'use strict';
	/**
	 * __Form Service - 0.5.21 - 20 FEB 2019
	 * 
	 * Form Setup & Validation Service.
	 *
	 * @return void
	 *-------------------------------------------------------- */

	angular.module("lw.form.main", []).
		config(["$httpProvider", function ($httpProvider) {

			// to detect ajax request at server side;
			$httpProvider.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

		}]).
		service("__Form", [
			'__Utils', '__Security', '__DataStore', '$rootScope', __Form
		]).
		directive("lwFormField", [
			'__Form', lwFormField
		]).
		directive("lwFormMessages", [
			'__Form', lwFormMessages
		]);

	function __Form(__Utils, __Security, __DataStore, $rootScope) {

		this.messages = __globals.messages.validation;
		this.NOTHING_CHANGED_MSG = 14; //this.messages.reactions['14']; // No changes
		this.INVALID_FORM_MSG = 4;  //this.messages.reactions['4']; // Client Side Validation Error
		this.REQUEST_SUCCESS_MSG = 1;  //this.messages.reactions['1']; // Success 
		this.YES_SECURITY_ID = __Security.getSecurityID();
		this.OLD_FORMDATA_ID_PREFIX = 'OFD_';

		var _form = this;

		// get validation message
		this.getMsg = function (key, labelName) {

			return this.messages[key].replace(":attribute", labelName.toLowerCase());

		};

		// get size related validation messages
		this.getSizeMsg = function (key, labelName, value) {

			var msg = this.messages[key]['string'];
			msg = msg.replace(":attribute", labelName.toLowerCase());

			// key is min    
			if (key === "min") {

				return msg.replace(":min", value);

			} else {

				return msg.replace(":max", value);

			}

		};

		// get number field size related validation message
		this.getNumberMsg = function (key, labelName, value) {

			var msg = this.messages[key]['numeric'];
			msg = msg.replace(":attribute", labelName.toLowerCase());

			// key is min    
			if (key === "min") {

				return msg.replace(":min", value);

			} else {

				return msg.replace(":max", value);

			}

		};

	    /**
		 * Update Model 
		 * 
		 * @param object {scope} 			- current controller scope
		 * @param string {ngFormName} 		- form name
		 * @param string {ngFormModelName} 	- model name
		 *
		 * return Object
		 *-------------------------------------------------------- */

		this.setup = function (scope, ngFormName, ngFormModelName, options) {

			scope.ngFormName = ngFormName;
			scope.ngFormModelName = ngFormModelName;
			scope[ngFormModelName] = {};
			scope[ngFormName + '_modelUpdateWatcher'] = true;

			if (options) {

				// option to encrypt form or not
				if (options.secured === true) {
					scope[ngFormName + this.YES_SECURITY_ID] = true;
					// check & recored if some form fields are exempted from encryption
					if (_.has(options, 'unsecuredFields') && (_.isArray(options.unsecuredFields) === true)) {
						scope[ngFormName + 'UNSECURED_FORM_FIELDS'] = options.unsecuredFields;
					}
				}

				// option to disable modelUpdate check for form submission
				if (options.modelUpdateWatcher === false) {
					scope[ngFormName + '_modelUpdateWatcher'] = false;
				}

			}

			return scope;
		};

	    /**
		 * Update Model 
		 * 
		 * @param object {scope} 	- current controller scope
		 * @param object {dataObj} 	- data object
		 *
		 * return Object
		 *-------------------------------------------------------- */

		this.updateModel = function (scope, dataObj) {

			scope[scope.ngFormModelName] = dataObj;
			scope[this.OLD_FORMDATA_ID_PREFIX + scope.ngFormModelName]
				= __Utils.stringifyObjectValues(dataObj);
			return scope;
		};

	    /**
		 * The process methods validate form and sent -
		 * post request to server and response back.
		 * If form invalidated, give the notification.
		 * 
		 * @param object {scope} - current controller scope
		 * @param string {actionURL} - action url
		 *
		 * return void
		 *-------------------------------------------------------- */

		this.process = function (actionURL, scope) {

			// Execution Starts
			__Utils.time("__Form.process");

			var formModelData = {},
				modelUpdateWatcher = scope[scope.ngFormName + '_modelUpdateWatcher'],
				postOptions = [];

			// check if this form needs encryption if yes encrypt values
			if (scope[scope.ngFormName + this.YES_SECURITY_ID]) {

				postOptions.unsecuredFields = scope[scope.ngFormName + 'UNSECURED_FORM_FIELDS'];
				postOptions.secured = true;
				// NOTE: Encryption logic moved to __DataStore.post - 06 JAN 2017

			}

			formModelData = scope[scope.ngFormModelName];

			var formScope = scope[scope.ngFormName],
				isModelUpdated = true,
				$currentFormElement = angular.element('form[name="' + formScope.$name + '"]');

			if ($currentFormElement.hasClass('lw-ng-form-processing')) {

				__Utils.warn("__Form:: Already in process");

				return {
					success: function (callbackFunction) {

						callbackFunction.call(this, {
							reaction: 14, // treat as a clientside validation error
							data: {
								message: "Already in process"
							}
						});

						// Execution Ends
						__Utils.timeEnd("__Form.process");

					},
					error: function (callbackFunction) {

						callbackFunction.call(this, false);

						// Execution Ends
						__Utils.timeEnd("__Form.process");
					}
				};
			}

			$currentFormElement.addClass('lw-ng-form-processing');

			if (modelUpdateWatcher === true) {
				// check if model updated or not
				isModelUpdated = _.isEqual(
					__Utils.stringifyObjectValues(scope[scope.ngFormModelName]),
					scope[this.OLD_FORMDATA_ID_PREFIX + scope.ngFormModelName]
				) ? false : true;

			}

			scope.errorMessage = '';
			scope.successMessage = '';

			if (formScope.$valid === true && isModelUpdated === true) {

				__Utils.info("__Form:: ClientSide validation passed");

				var _validation = this;

				$rootScope.$broadcast('lw.form.event.process.started');

				return __DataStore.post(actionURL, formModelData, postOptions)
					.success(function (responseData) {

						scope.successMessage = __globals.getReactionMessage(
							_validation.REQUEST_SUCCESS_MSG);

						var requestData = responseData.data;

						// if request success
						if (responseData.reaction === 1) {

							__Utils.info("__Form:: ServerSide validation/check passed");
							scope.errorMessage = "";

							if (requestData.message) {
								scope.successMessage = requestData.message;
							}

							// update form validation messages
							_validation.update(formScope, null);

							// update old model info
							_validation.updateModel(scope, scope[scope.ngFormModelName]);

							$currentFormElement.removeClass('lw-ng-form-processing');

						} else {

							__Utils.warn("__Form:: Serverside validation/check failed");
							// if request data wrong
							scope.errorMessage = requestData.message;
							scope.successMessage = '';

							// update form validation messages
							_validation.update(formScope, requestData.validation);

							_.defer(function () {
								$currentFormElement.removeClass('lw-ng-form-processing');

								// find the first invalid element
								var firstInvalid = angular.element('form').find('.ng-invalid')[0];
								// if we find one, set focus
								if (firstInvalid) {
									if (angular.element(firstInvalid).hasClass('selectized')) {
										$(firstInvalid).parent().find('input').focus();
									} else {
										firstInvalid.focus();
									}
								}
							})

						}

						__Utils.info("__Form:: Request processed");

						// fire events
						$rootScope.$broadcast('lw.form.event.process.finished', responseData);
						$rootScope.$broadcast('lw.form.event.process.success', responseData);

						// Execution Ends
						__Utils.timeEnd("__Form.process");

					}).error(function () {

						__Utils.error("__Form:: Serverside error");

						$currentFormElement.removeClass('lw-ng-form-processing');
						// fire events
						$rootScope.$broadcast('lw.form.event.process.finished', false);
						$rootScope.$broadcast('lw.form.event.process.error');

						// Execution Ends
						__Utils.timeEnd("__Form.process");
					});

			} else if (formScope.$valid === true && isModelUpdated === false) {

				scope.errorMessage = __globals.getReactionMessage(
					this.NOTHING_CHANGED_MSG);

				__Utils.warn("__Form:: Nothing new to process");

				$currentFormElement.removeClass('lw-ng-form-processing');

				return {
					success: function (callbackFunction) {

						callbackFunction.call(this, {
							reaction: 14, // treat as a clientside validation error
							data: {
								message: scope.errorMessage
							}
						});

						// Execution Ends
						__Utils.timeEnd("__Form.process");
						$currentFormElement.removeClass('lw-ng-form-processing');

					},
					error: function (callbackFunction) {

						callbackFunction.call(this, false);

						// Execution Ends
						__Utils.timeEnd("__Form.process");
						$currentFormElement.removeClass('lw-ng-form-processing');
					}
				};

			} else {

				// if form invalid, set form submitted true for show error message
				scope[scope.ngFormName].submitted = true;

				scope.errorMessage = __globals.getReactionMessage(
					this.INVALID_FORM_MSG);

				return {
					success: function (callbackFunction) {

						$currentFormElement.removeClass('lw-ng-form-processing').addClass('lw-form-has-errors');

						// find the first invalid element
						var firstInvalid = angular.element('form').find('.ng-invalid')[0];
						// if we find one, set focus
						if (firstInvalid) {
							if (angular.element(firstInvalid).hasClass('selectized')) {
								$(firstInvalid).parent().find('input').focus();
							} else {
								firstInvalid.focus();
							}
						}

						__Utils.warn("__Form:: ClientSide validation failed");

						callbackFunction.call(this,
							{
								reaction: 4,
								data: { message: scope.errorMessage }
							});

						// Execution Ends
						__Utils.timeEnd("__Form.process");

					},
					error: function (callbackFunction) {

						$currentFormElement.removeClass('lw-ng-form-processing');

						__Utils.error("__DataStore:: Ooops... Something went wrong");
						callbackFunction.call(this, false);

						// Execution Ends
						__Utils.timeEnd("__Form.process");

					}
				};
			}
		};

	    /**
		 * Alias to __DataStore.fetch
		 * including event broadcast for fetch started 
		 * 
		 * @param string {urlID} - urlID
		 * @param object {options} 
		 *
		 * return object
		 *-------------------------------------------------------- */

		this.fetch = function (urlID, options) {

			$rootScope.$broadcast('lw.form.event.fetch.started');

			return __DataStore.fetch(urlID, options);
		};

	    /**
		 * Update Current Form Validation Messages 
		 * 
		 * @param object {formObj} - current form object
		 * @param object {validationMsgs} - validation messages
		 *
		 * return void
		 *-------------------------------------------------------- */

		this.update = function (formObj, validationMsgs) {

			var fields = [];

			_.each(formObj, function (obj, key) {

				if (key[0] !== "$") {

					fields.push(key);

					if ((obj.hasOwnProperty("$error")) && (obj.$error.hasOwnProperty("server"))) {
						formObj[key].$error = {};
						angular.element('form').find('[name="' + key + '"]').removeClass('ng-invalid');
					}

				}

			});

			if (!$.isEmptyObject(validationMsgs)) {

				_.each(fields, function (key) {

					if (validationMsgs.hasOwnProperty(key)) {
						angular.element('form').find('[name="' + key + '"]').addClass('ng-invalid');
						formObj[key].$error = { 'server': validationMsgs[key][0] };
					}

				});
			}

		};

	};

	/**
	 * lwFormField Directive - 0.1.0 - 12 JUN 2015
	 * 
	 * Form Input Field Directive.
	 *
	 * @inject __Form
	 *
	 * @return void
	 *-------------------------------------------------------- */

	function lwFormField(__Form) {

		return {
			restrict: 'E',
			replace: true,
			transclude: true,
			scope: {
				fieldFor: '@'
			},
			templateUrl: 'lw-form-text.ngtemplate',
			link: function (scope, elem, attrs, ctrls, transclude) {

				// remove ng-transclude for 
				// angular material inputs as per 0.9.5
				if (elem.hasClass('lw-remove-transclude-tag')) {
					elem.find('ng-transclude').children().unwrap();
				}

				// field form data
				var formData = elem.parents('form.lw-ng-form')
					.data('$formController'),

					inputElement = elem.find('.lw-form-field');

				inputElement.prop('id', scope.fieldFor);
				// form field object 
				scope.formField = {};
				scope.formField[scope.fieldFor] = attrs;

				scope.lwFormData = {
					formCtrl: formData
				};

				// get validation message
				scope.getValidationMsg = function (key, labelName) {
					return __Form.getMsg(key, labelName);
				};

				// get size relared validation message
				scope.getSizeValidationMsg = function (key, labelName) {

					var value;
					if (key === "min") {

						value = inputElement.attr('ng-minlength');

					} else {

						value = inputElement.attr('ng-maxlength');

					}

					return __Form.getSizeMsg(key, labelName, value);

				};

				// get number field size related validation messages
				scope.getMinMaxValidationMsg = function (key, labelName) {


					if (key === "min") {

						return __Form.getNumberMsg(key, labelName, inputElement.attr('min'));

					} else {

						return __Form.getNumberMsg(key, labelName, inputElement.attr('max'));

					}

				};

			}
		};

	}

    /**
     * lwFormMessages Directive - 0.1.0 - 17 AUG 2015
     * 
     * Show form messages
     *
     * @return void
     *-------------------------------------------------------- */

	function lwFormMessages() {
		return {
			restrict: 'E',
			replace: true,
			transclude: true,
			scope: true,
			templateUrl: 'lw-form-messages.ngtemplate',
			link: function (scope, elem, attrs, transclude) {
				scope.ctrlName = attrs.ctrlName;
			}

		};
	};

})(); 